import { useCallback } from "react";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { stringify } from "query-string";
import { urlReplacer } from "../../../utils";
import {
  IGetServiceBackEndModel,
  IGetViewServiceBackEndModel,
  IServiceByProviderListItemBackEndModel,
  IViewMoreContactsBackEndModel,
  IViewMoreServiceBackEndModel,
} from "../types";

export default function () {
  const { request } = useApi();

  return {
    getServicesList: useCallback(
      async (
        filter,
      ): Promise<{ data: IServiceByProviderListItemBackEndModel[] }> => {
        return request({
          method: "GET",
          url:
            ApiRoutes.GET_SERVICES_LIST_FOR_PROVIDER + "?" + stringify(filter),
        });
      },
      [request],
    ),

    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.SERVICES_CONTROLLER,
        });
      },
      [request],
    ),

    update: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "PUT",
          url: ApiRoutes.SERVICES_CONTROLLER,
        });
      },
      [request],
    ),

    uploadDetailFile: useCallback(
      (file) => {
        let formData = new FormData();
        formData.append("file", file);
        return request({
          method: "POST",
          url: `${ApiRoutes.UPLOAD_SERVICE_DETAIL_FILE}`,
          data: formData,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id): Promise<{ data: IGetServiceBackEndModel }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.ONE_SERVICE, { id })}`,
        });
      },
      [request],
    ),

    fetchView: useCallback(
      async (id): Promise<{ data: IGetViewServiceBackEndModel }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.VIEW_ONE_SERVICE, { id })}`,
        });
      },
      [request],
    ),

    fetchViewMore: useCallback(
      async (id): Promise<{ data: IViewMoreServiceBackEndModel }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_VIEW_MORE_SERVICE, { id })}`,
        });
      },
      [request],
    ),

    fetchContacts: useCallback(
      async (id): Promise<{ data: IViewMoreContactsBackEndModel }> => {
        const url = ApiRoutes.GET_SERVICE_CONTACTS;
        return request({
          method: "GET",
          url: `${urlReplacer(url, { id })}`,
        });
      },
      [request],
    ),

    deleteOne: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.ONE_SERVICE, { id })}`,
        });
      },
      [request],
    ),

    getStudents: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_STUDENTS_FOR_APPLY_AS, { id })}`,
        });
      },
      [request],
    ),
    getServiceListByCategory: useCallback(
      async (categoryName) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.SERVICE_LIST_BY_CATEGORY, { categoryName })}`,
        });
      },
      [request],
    ),
  };
}
